import { useCallback, useEffect, useMemo, useState } from 'react';
import cls from 'classnames';
import Header from '@/components/sciex/Header';
import Nav from '@/components/sciex/Nav';
import Productions from '@/components/sciex/Productions';
import Footer from '@/components/sciex/Footer';
import styles from './index.module.scss';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useNavigate } from 'react-router';
import Request from '@/utils/Request';

export default () => {
  const [searchKey, setSearchKey] = useState<string>('');
  const [dataSource, setDataSource] = useState<Record<string, any>>({});
  const navigate = useNavigate();
  const searchHandle = useCallback(() => {
    if (!searchKey) {
      return;
    }
    navigate(`/searchPage?keyword=${searchKey}`);
  }, [navigate, searchKey]);
  const gotoDetail = useCallback((item: any) => {
    if (item.redirectUrl) {
      window.open(item.redirectUrl);
    }
  }, []);
  const suffix = useMemo(() => {
    return <SearchOutlined className={styles['search-icon']} onClick={() => searchHandle()} />;
  }, [searchHandle]);
  const loadData = useCallback(async () => {
    const res = await Request.post(`/sciex`, {});
    console.log('res====', res);
    if (res.errno === 0) {
      setDataSource(res.data);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);
  const searchMenus = useMemo(() => {
    return (
      <div className={styles['search-content']}>
        <div className={cls(styles['search-main'], 'flex', 'v-center')}>
          <div className={cls(styles['search-input-waper'], 'flex1')}>
            <Input
              placeholder=""
              className={styles['search-input']}
              suffix={suffix}
              onPressEnter={(e) => searchHandle()}
              onInput={(e: any) => {
                console.log('e====', e.nativeEvent.target.value);
                setSearchKey(e.nativeEvent.target.value);
              }}
            />
          </div>
          <div className={styles['right-menu']}>所有商品分类</div>
        </div>
      </div>
    );
  }, [searchKey, suffix]);
  const hostProduction = useMemo(() => {
    return (
      <div className={styles['hots-content']}>
        <div className={styles['hots-title']}>热销产品</div>
        <div className={cls(styles['hots-list'], 'flex')}>
          {(dataSource.hotGoods || []).map((item: any) => {
            return (
              <div className={cls(styles['hots-item'], 'flex1')} key={item.id}>
                <div className={styles['img-pic']} onClick={() => gotoDetail(item)}>
                  <img src={item.url} style={item.styles ?? {}} />
                </div>
                <p>{item.title}</p>
              </div>
            );
          })}
        </div>
      </div>
    );
  }, [dataSource, gotoDetail]);
  return (
    <div className={cls(styles['sciex-page'])}>
      <Header />
      {searchMenus}
      <Nav navs={dataSource.goodsCategory} slideshow={dataSource.slideshow} />
      {hostProduction}
      <Productions dataSource={dataSource.floors} />
      <Footer />
    </div>
  );
};
